import React, { ComponentPropsWithRef, useEffect, useMemo, useState } from "react";

import _ from "lodash";
import cx from "classnames";

import { AssessmentParameter, Simulation } from "src/types/coaching/simulation";

import Actions from "src/components/actionbar";
import { SimulationContext } from "../../context";

import styles from "./assessments.module.scss";

interface AssessmentSettingsProps {
  simulation: Simulation;
}

export const AssessmentSettings: React.FC<AssessmentSettingsProps> = ({ simulation }) => {
  const simulationContext = React.useContext(SimulationContext);

  const parameters = useMemo(() => {
    return _.get(simulation, "assessmentConfiguration.parameters") || [];
  }, [simulation]);

  const handleEditParameter = (parameter) => {
    if (simulationContext.editAssessmentParameter) {
      simulationContext.editAssessmentParameter(parameter);
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h6>Define evaluation criteria aligned with your sales methodology and target skills.</h6>
      </div>
      <div className={styles.body}>
        <div className={styles.headers}>
          <div className={styles.header}>Skill Categories</div>
          <div className={styles.header}>Specific Behaviors</div>
          <div className={styles.header}>Success Indicators</div>
        </div>
        {parameters.map((parameter, index) => (
          <ParameterCard key={index} 
            simulation={simulation}
            parameter={parameter}
          />
        ))}
      </div>
    </div>
  );
}

interface ParameterCardProps {
  simulation: Simulation;
  parameter: AssessmentParameter;
}

const ParameterCard: React.FC<ParameterCardProps> = ({ simulation, parameter }) => {
  return (
    <div className={styles.card}>
      <div className={styles.parameter}>
        <h6 className={styles.name}>{parameter.name}</h6>
        <div className={styles.weightage}>
          weightage for this assessment:
          <b className={styles.value}>{parameter.weightage}</b>
        </div>
      </div>
      <div className={styles.subParameters}>
        {parameter.parameters.map((subParameter) => (
          <div key={subParameter.uid} className={styles.subParameter}>
            <label className={styles.name}>{subParameter.name}</label>
            <div className={styles.value}>{subParameter.criteria}</div>
          </div>
        ))}
      </div>
    </div>
  );
}